import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import GridItem from 'src/components/grid-item/GridItem'
import { SerasaPersonRow } from 'src/modules/motor-credito/serasa/serasa.pf.types'

export type EnderecoProps = {
    person: SerasaPersonRow
}

export default function Endereco({ person }: EnderecoProps) {
    if (!person.localizacao) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Endereço</Divider>

            <Grid
                container
                spacing={1}
                sx={{
                    paddingTop: 2,
                    paddingBottom: 2,
                    paddingLeft: 5,
                    paddingRight: 5
                }}
            >
                <GridItem label="Desde" value={person.localizacao.desde} xs={12} />
                <GridItem label="Endereço" value={person.localizacao.endereco} xs={12} />
                <GridItem label="Bairro" value={person.localizacao.bairro} xs={6} />
                <GridItem label="Cidade" value={person.localizacao.cidade} xs={6} />
                <GridItem label="Uf" value={person.localizacao.uf} xs={6} />
                <GridItem label="CEP" value={person.localizacao.cep} xs={6} />
            </Grid>
        </>
    )
}
